import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import logo from './logo.jpg';
import logoSVG from './logo.svg';
import useResize from '@/hooks/useResize';
import useCurrentLang from '@/hooks/useCurrentLang';

const LogoWrapper = styled.div<{ isMobile: boolean; useMobileNavigation: boolean; registDone: boolean }>`
  min-width: 0;

  img {
    height: ${(p) => (p.isMobile ? '27px' : p.useMobileNavigation ? '40px' : '70px')};
    max-width: 100%;
    object-fit: contain;
    position: ${(p) => (p.useMobileNavigation ? 'relative' : p.registDone ? 'absolute' : 'relative')};
    top: ${(p) => (p.useMobileNavigation ? '0' : p.registDone ? '15px' : '0')};
  }
`;

interface LogoProps {
  registDone: boolean;
  setBurgerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setUserOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isLogin: boolean;
  useMobileNavigation: boolean;
  constrainMobileLogo: boolean;
}

const Logo = ({
  isLogin,
  setUserOpen,
  setBurgerOpen,
  registDone,
  useMobileNavigation,
  constrainMobileLogo,
}: LogoProps) => {
  const { isMobile } = useResize();
  const currentLang = useCurrentLang();
  const closeModalHanlder = () => {
    setUserOpen(false);
    setBurgerOpen(false);
  };

  return (
    <>
      {registDone ? (
        <RouterLink
          onClick={closeModalHanlder}
          to={isLogin ? '/home' : `/${currentLang}`}
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            flexShrink: constrainMobileLogo && useMobileNavigation ? 1 : 0,
            minWidth: 0,
          }}
        >
          <LogoWrapper registDone={registDone} isMobile={isMobile} useMobileNavigation={useMobileNavigation}>
            <img src={logo} alt="logo" />
          </LogoWrapper>
        </RouterLink>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            flexShrink: constrainMobileLogo && useMobileNavigation ? 1 : 0,
            minWidth: 0,
          }}
        >
          <LogoWrapper registDone={registDone} isMobile={isMobile} useMobileNavigation={useMobileNavigation}>
            {isMobile ? <img src={logoSVG} alt="logo" /> : <img src={logo} alt="logo" />}
          </LogoWrapper>
        </div>
      )}
    </>
  );
};

export default Logo;
